import _axios from "../../libs/axios";

export default (context) => {

  let roles = [];

  _axios.get('admGroup/getTypes')
  .then(r => {
      roles = r.data.Results     
  });

  const M = "admGroup."
  return {
    config: {
      pageSize: 50,
      remap: (r) => {
        if (r.status >= 0) {
          r.data.Results = r.data.Results.map(item => {
            const role = roles.find(role => role.ID === item.type);
            if (role)item.type = role.name;
            return item;
          });
        }
        return r;
      },
      remapRow: (form, responseData) => {
        return { ...form, ID: responseData }
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter: {
      fields: [
        {
          name: "staff",
          value: 1,
          type: "select",
          label: "main.type",
          opts: {
            style: 'float-label',
            items: [
              {
                value: 0,
                label: "All"
              },
              {
                value: 1,
                label: "Staff"
              },
              {
                value: 2,
                label: "Users"
              }
            ]
          }
        }
      ],
      buttons: [
        {
          label: "main.applyFilter",
          renderIf: (ctx) => { return Number.isInteger(ctx.state.staff) },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.type = { value: r.data.type, label: roles.find(f => f.ID === r.data.type)?.name || '-' }
        }
        return r
      },
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "hidden",
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "type",
          value: null,
          type: "select",
          label: `${M}userGroupType`,
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admGroup/getTypes?pick=true",
          }
        },
        {
          col: 12,
          name: "desc",
          value: null,
          type: "textarea",
          rules: "max:255",
          label: "main.desc",
          opts: {
            style: 'float-label',
            rows: 3
          }
        },
        {
          col: 12,
          name: "staff",
          value: false,
          type: "switch",
          label: `${M}staffAdmin`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "canRead",
          value: null,
          type: "select",
          label: `${M}permissionsRead`,
          rules: "required",
          opts: {
            style: 'float-label',
            path: '/admModule/get?pick=true&classic=false',
            isMulti: true,
            setOutput: (v) => {
              if (v) return v.map((m) => { return { ID: m.value, name: m.label, selected: true } })
            }
          },
          renderIf: (ctx) => { return ctx.state.staff }
        },
        {
          col: 12,
          name: "canEdit",
          value: null,
          type: "select",
          label: `${M}permissionsWrite`,
          opts: {
            style: 'float-label',
            path: '/admModule/get?pick=true&classic=false',
            isMulti: true,
            setOutput: (v) => {
              if (v) return v.map((m) => { return { ID: m.value, name: m.label, selected: true } })
            }
          },
          renderIf: (ctx) => { return ctx.state.staff }
        },
        {
          col: 12,
          name: "categories",
          value: null,
          type: "select",
          label: "main.categories",
          opts: {
            style: 'float-label',
            path: '/admCategory/get?pick=true',
            isMulti: true,
            setOutput: (v) => {
              if (v) return v.map((m) => { return { ID: m.value, name: m.label, selected: true } })
            }
          },
          renderIf: (ctx) => { return ctx.state.staff }
        },
        {
          col: 12,
          name: "forceLogout",
          value: false,
          type: "switch",
          label: `${M}forceLogout`,
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => { return ctx.state.staff }
        },
        {
          col: 12,
          name: "members",
          value: null,
          type: "select",
          label: `${M}members`,
          rules: "required",
          opts: {
            style: 'float-label',
            path: 'admUser/get?type=2&pick=true',
            withImg: true,
            isMulti: true,
            searchOnline: true,
            setOutput: (v) => {
              if (v) return v.map((m) => { return { ID: m.value, name: m.label, selected: true } })
            }
          },
          renderIf: (ctx) => { return false }
        }
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name",
      },
      {
        Header: "main.staff",
        accessor: "staff",
        isBool: true
      },
      {
        Header: "main.type",
        accessor: "type",
      }
    ]
  }
}